import { render, staticRenderFns } from "./addPanCard.vue?vue&type=template&id=5d8e1699"
import script from "./addPanCard.vue?vue&type=script&lang=js"
export * from "./addPanCard.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports